export const testimonialActions = {
  GET_TESTIMONALS_PENDING: 'GET_TESTIMONALS_PENDING',
  GET_TESTIMONALS_SUCCESS: 'GET_TESTIMONALS_SUCCESS',
  GET_TESTIMONALS_ERROR: 'GET_TESTIMONALS_ERROR',
};
